import { render, staticRenderFns } from "./ResourceFilters.vue?vue&type=template&id=3c2f30c4&scoped=true&"
import script from "./ResourceFilters.vue?vue&type=script&lang=js&"
export * from "./ResourceFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f30c4",
  null
  
)

export default component.exports